import Vue from 'vue';
import {
  chat, updateChatStatus
} from '../../../services/backendService/chatService';

 // initial state
 // state 必為模組區域變數，取時需 store.state.auth.user
 // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
 // 區域使用時值需加上 name
const state = {
  msgList: [],
  pagination: {
    current_page: 0,
    per_page: 30,
    search_msg: ""
  },
  personnelProfilePicture: null,
  sa_id: null
};

 // getters
 const getters = {};

 // actions
const actions = {
  // 取得對話列表
  async getChatListHandler({ commit }, params) {
    const data = await chat(params);
    commit('setMsgList', data);
    commit('setPersonnelProfilePicture', data.data.sa_picture);
    commit('setSaID', data.data.sa_id);
  },
  // 對話 狀態貼標
  async updateChatStatusHandler({ commit }, data) {
    await updateChatStatus(data);
  }
};

// mutations
const mutations = {
  setMsgList(state, data) {
    Vue.set(state, 'msgList', state.msgList.concat(data.data.data));
    Vue.set(state, 'pagination', data.pagination);
  },
  // 重置所有資料
  resetHandler(state) {
    Vue.set(state, 'msgList', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 30,
      search_msg: ""
    });
    Vue.set(state, 'personnelProfilePicture', null);
    Vue.set(state, 'sa_id', null);
  },
  setPersonnelProfilePicture(state, data) {
    Vue.set(state, 'personnelProfilePicture', data ? data : null);
  },
  setSaID(state, SaID) {
    Vue.set(state, 'sa_id', SaID ? SaID : null);
  }
};

 export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
 };
